import { useState, useEffect } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import scrollToSection from './scrollToSection';
const { FiMenu, FiX, FiPhone } = FiIcons;

function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const go = (id) => { scrollToSection(id); setOpen(false); };
  return (
    <header className={scrolled ? 'site-header scrolled' : 'site-header'}>
      <div className="header-inner">
        <a className="brand" href="#top" onClick={(e) => { e.preventDefault(); go('top'); }}>
          <span className="brand-mark">H</span>
          <span className="brand-name">Havenfield<small>PROPERTY CONSULTANTS</small></span>
        </a>
        <button className="menu-toggle" aria-label="Menu" onClick={() => setOpen(!open)}>
          <SafeIcon icon={open ? FiX : FiMenu} />
        </button>
        <nav className={open ? 'main-nav open' : 'main-nav'}>
          <button onClick={() => go('about')}>Approach</button>
          <button onClick={() => go('services')}>Services</button>
          <button onClick={() => go('listings')}>Properties</button>
          <button onClick={() => go('process')}>Process</button>
          <button onClick={() => go('team')}>Team</button>
          <button className="nav-cta" onClick={() => go('contact')}>Book a call</button>
        </nav>
      </div>
    </header>
  );
}
export default Header;
